import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  OffcanvasHeader,
  OffcanvasBody,
  Offcanvas,
  Row,
  Col,
  Card,
  Label,
  FormGroup,
  Input,
  InputGroup,
  ButtonGroup,
  CardHeader,
  InputGroupText,
  CardBody,
  Badge,
  Alert,
  Spinner,
} from "reactstrap";
import restro from "../../../../../assets/orderingSystem/restrologo.png";
import PaymentTypeServices from "../../../../../services/OrderingServices/PaymentTypeService";
import { useReactToPrint } from "react-to-print";
import InvoiceSummary from "./InvoiceSummary";
import { PrintBill } from "../../../BillPrint/page/PrintBill";
import InvoiceSummaryMobile from "./InvoiceSummaryMobile";
import CreditModal from "../../../../../Components/Modal/CreditModal";
import toast from "react-hot-toast";
import SectionService from "../../../../../services/OrderingServices/SectionService";

const ConfirmPayment = (props) => {
  const {
    isOpen,
    toggle,
    handleCheckout,
    billData,
    selectedPayment,
    setSelectedPayments,
    selectedPayments,
    handleApplyPromo,
    setPromoCode,
    promoCode,
    calculateTotals,
    handlePercentChange,
    Credit,
    discountPercent,
    setDiscountPercent,
    discountAmount,
    setDiscountAmount,
    promoSuccess,
    setPromoSuccess,
    promoError,
    setPromoError,
    selectedTable,
    setLastUpdated,
    user,
    selectedCustomer,
    orgInfo,
    toggleListModal,
    setCreditData,
    creditData,
    paymentAmounts,
    setPaymentAmounts,
    handleAmountChange,
    placedItems,
    responseData,
    isTakeawayPaymentPending,
    setIsTakeawayPaymentPending,
    handleUnmergeTable,
    selectedAttributes,
    itemPrice,
  } = props;
  console.log("🚀 ~ ConfirmPayment ~ placedItems:", placedItems);

  const localUser = JSON.parse(localStorage.getItem("user")) || {};
  const userInfo = localUser?.user || {};

  const [expandedItems, setExpandedItems] = useState({});
  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const orderKey = selectedTable?.id || "takeaway";
  const rawOrder = billData?.[orderKey] || {};
  console.log("🚀 ~ ConfirmPayment ~ rawOrder:", rawOrder);
  const itemsToShow = placedItems?.length ? placedItems : rawOrder?.items || [];
  console.log("🚀 ~ ConfirmPayment ~ itemsToShow:", itemsToShow);
  const orderId = rawOrder?.orderId || "N/A";

  const printRef = useRef();
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(selectedPayment || null);
  const [paymentStatus, setPaymentStatus] = useState(
    selectedPayment?.name ? "Paid" : "UnPaid",
  );
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isCreditOpen, setIsCreditOpen] = useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);

  if (!rawOrder) return null;

  const toggleInvoice = () => {
    setIsInvoiceOpen(!isInvoiceOpen);
  };

  const fetchData = async () => {
    try {
      const response = await PaymentTypeServices.getList();
      setData(response);
      setError(null);
    } catch (error) {
      console.error("Failed to fetch payment types:", error);
      setError("Unable to load payment methods. Please try again.");
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedPayment) {
      setPaymentStatus("Paid");
    } else {
      setPaymentStatus("UnPaid");
    }
  }, [selectedPayment]);

  useEffect(() => {
    setSelected(selectedPayment);
  }, [selectedPayment]);

  useEffect(() => {
    if (selectedCustomer === null) {
      setTimeout(() => {
        setDiscountPercent("");
        setDiscountAmount("");
        setPromoSuccess(false);
        setPromoError(null);
        setPromoCode("");
      }, 0);
    }
  }, [selectedCustomer]);

  const handleSelect = (payment) => {
    const isCredit = payment.name.toLowerCase().includes("credit");

    if (isCredit) {
      setSelectedPayments((prev) => {
        if (!prev.some((item) => item.id === payment.id)) {
          return [...prev, payment];
        }
        return prev;
      });

      // Calculate remaining amount after other payment methods
      const nonCreditPayments = selectedPayments.filter(
        (p) => !p.name.toLowerCase().includes("credit"),
      );

      let otherPaymentsTotal = 0;
      nonCreditPayments.forEach((p) => {
        otherPaymentsTotal += parseFloat(paymentAmounts[p.id]) || 0;
      });

      const remainingAmount = Math.max(
        0,
        calculateTotals.total - otherPaymentsTotal,
      );

      setCreditData((prev) => ({
        ...prev,
        amount:
          prev?.amount && Number(prev.amount) > 0
            ? prev.amount
            : remainingAmount.toFixed(2),
        customerId: selectedCustomer?.id || prev?.customerId,
      }));
      setIsCreditOpen(true);
    } else {
      setSelectedPayments((prev) => {
        const alreadySelected = prev.some((item) => item.id === payment.id);
        let newPayments;

        if (alreadySelected) {
          newPayments = prev.filter((item) => item.id !== payment.id);
          setPaymentAmounts((amtPrev) => {
            const { [payment.id]: _, ...rest } = amtPrev;
            return rest;
          });
        } else {
          newPayments = [...prev, payment];
        }

        return newPayments;
      });
    }
  };

  const toggleCreditModal = (value) => {
    setIsCreditOpen(value ?? false);
  };

  const handleCreditAmountChange = (id, value) => {
    setPaymentAmounts((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const totalPaid = useMemo(() => {
    let sum = 0;

    selectedPayments.forEach((item) => {
      const isCredit = item.name.toLowerCase().includes("credit");

      if (isCredit) {
        sum += parseFloat(creditData?.amount) || 0;
      } else {
        sum += parseFloat(paymentAmounts[item.id]) || 0;
      }
    });

    return sum;
  }, [selectedPayments, creditData, paymentAmounts]);

  const isValidAmount = () => {
    if (!selectedPayments?.length) return false;

    // Calculate total paid
    const totalPaidAmount = selectedPayments.reduce((sum, item) => {
      const isCredit = item.name.toLowerCase().includes("credit");
      const amount = isCredit
        ? parseFloat(creditData?.amount || 0)
        : parseFloat(paymentAmounts[item.id] || 0);
      return sum + amount;
    }, 0);

    // Check each amount > 0
    const allPositive = selectedPayments.every((item) => {
      const isCredit = item.name.toLowerCase().includes("credit");
      const amount = isCredit
        ? parseFloat(creditData?.amount || 0)
        : parseFloat(paymentAmounts[item.id] || 0);
      return amount > 0;
    });

    // Must be positive AND >= total
    return allPositive && totalPaidAmount >= calculateTotals.total;
  };

  const returnAmount = useMemo(() => {
    if (!calculateTotals.total) return 0;
    return totalPaid > calculateTotals.total
      ? totalPaid - calculateTotals.total
      : 0;
  }, [totalPaid, calculateTotals.total]);

  useEffect(() => {
    if (!selectedPayments?.length) return;

    const total = Number(calculateTotals.total);

    // Get current credit amount from selectedPayments
    const creditPayment = selectedPayments.find((p) =>
      p.name.toLowerCase().includes("credit"),
    );
    const currentCreditAmount = creditPayment
      ? parseFloat(creditData?.amount || 0)
      : 0;

    setPaymentAmounts((prev) => {
      let updated = { ...prev };
      let changed = false;

      const nonCreditPayments = selectedPayments.filter(
        (p) => !p.name.toLowerCase().includes("credit"),
      );

      // If no non-credit payments, don't change anything
      if (nonCreditPayments.length === 0) {
        return prev;
      }

      // Case 1: Only ONE non-credit payment → auto-fill remaining amount
      if (nonCreditPayments.length === 1) {
        const pay = nonCreditPayments[0];
        const current = Number(prev[pay.id] || 0);

        // Calculate remaining amount after credit
        const amountForThisPayment = Math.max(0, total - currentCreditAmount);

        // Only auto-fill if the value is empty (user hasn't entered anything yet)
        if (current === 0) {
          updated[pay.id] = amountForThisPayment.toFixed(2);
          changed = true;
        }

        return changed ? updated : prev;
      }

      // Case 2: MULTIPLE payment methods selected
      const totalPaid = nonCreditPayments.reduce((sum, pay) => {
        const amount = Number(prev[pay.id] || 0);
        return sum + amount;
      }, 0);

      const remaining = Math.max(0, total - totalPaid - currentCreditAmount);

      // Find newly added payment (one that doesn't have an amount yet) and fill only the first one
      let filledOne = false;
      for (let i = 0; i < nonCreditPayments.length; i++) {
        const pay = nonCreditPayments[i];
        const current = Number(prev[pay.id] || 0);

        // Only fill the first empty payment method with the remaining amount
        if (
          !filledOne &&
          (current === 0 || current === undefined || prev[pay.id] === "")
        ) {
          updated[pay.id] = remaining.toFixed(2);
          changed = true;
          filledOne = true;
          break;
        }
      }

      return changed ? updated : prev;
    });
  }, [selectedPayments, calculateTotals.total, creditData]);

  // Update credit amount to remaining when other payments change
  useEffect(() => {
    const creditPayment = selectedPayments.find((p) =>
      p.name.toLowerCase().includes("credit"),
    );

    if (!creditPayment) return;

    // Calculate total of all non-credit payments
    let otherPaymentsTotal = 0;
    selectedPayments.forEach((pay) => {
      if (!pay.name.toLowerCase().includes("credit")) {
        otherPaymentsTotal += parseFloat(paymentAmounts[pay.id]) || 0;
      }
    });

    // Calculate remaining for credit
    const remainingForCredit = Math.max(
      0,
      calculateTotals.total - otherPaymentsTotal,
    );

    // Update credit amount to remaining if it was auto-filled or if current exceeds remaining
    const currentCreditAmount = parseFloat(creditData?.amount || 0);
    if (currentCreditAmount > remainingForCredit) {
      setCreditData((prev) => ({
        ...prev,
        amount: remainingForCredit.toFixed(2),
      }));
    }
  }, [paymentAmounts, selectedPayments, calculateTotals.total]);

  const resetCredit = () => {
    setIsCreditOpen(false);

    // Remove credit payment method
    setSelectedPayments((prev) =>
      prev.filter((p) => !p.name.toLowerCase().includes("credit")),
    );

    // Reset credit data
    setCreditData({
      amount: "",
      remarks: "",
      customerId: selectedCustomer?.id || null,
    });
  };

  return (
    <>
      <Offcanvas
        isOpen={isOpen}
        toggle={() => {
          if (isTakeawayPaymentPending) {
            toast.error("Please complete the payment to close.");
            return;
          }
          toggle();
        }}
        direction="end"
        backdrop={isTakeawayPaymentPending ? "static" : true}
        keyboard={!isTakeawayPaymentPending}
        backdropClassName="bg-dark bg-opacity-50"
        className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
        id="offcanvasRight"
      >
        <OffcanvasHeader className="d-block d-sm-none">
          <div className="d-flex w-100 rounded-top">
            <button
              className="btn btn-sm btn-light"
              onClick={() => {
                if (isTakeawayPaymentPending) {
                  toast.error("Please complete the payment to close.");
                  return;
                }
                resetCredit();
                toggle();
              }}
            >
              <i className="bx bx-chevron-left"></i>
            </button>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="text-center w-100">
                <h5 className="mb-0 fw-semibold">
                  Order #{orderId} [ {selectedTable?.tableName || "takeaway"}]
                </h5>
              </div>
              <button className="btn btn-sm btn-light" onClick={toggleInvoice}>
                Estimate
              </button>
            </div>
          </div>
        </OffcanvasHeader>
        <div
          className="position-absolute d-none d-sm-block"
          style={{ left: "-40px", top: "10px" }}
        >
          <button
            className="btn btn-sm btn-light"
            onClick={() => {
              if (isTakeawayPaymentPending) {
                toast.error("Please complete the payment to close.");
                return;
              }
              toggle();
            }}
          >
            <i className="ri-close-line"></i>
          </button>
        </div>
        {/* Desktop Header */}
        <div className="d-none d-sm-flex gap-3 justify-content-start align-items-center p-3 shadow-sm rounded-top">
          <i className="ri-stack-line"></i>
          <h5 className="mb-0 fw-bold">
            Order #{orderId} • {selectedTable?.tableName || "takeaway"}
          </h5>
        </div>
        <OffcanvasBody className="px-lg-4 px-2 py-3 bg-body-tertiary">
          <Row ref={printRef}>
            <Col md={7} lg={8}>
              <Card className="shadow-sm border-0 rounded-3">
                <CardHeader className="bg-light d-flex justify-content-between align-items-center rounded-top">
                  <h5 className="mb-0 fw-semibold">Order Items</h5>
                  <div
                    className="d-flex align-items-center gap-2 cursor-pointer"
                    onClick={toggleListModal}
                  >
                    <i
                      className="ri-user-line fs-4 text-primary"
                      title="Select Customer"
                    ></i>
                    <div>
                      <div className="text-muted small">Customer</div>
                      <h6 className="mb-0 fw-bold">
                        {selectedCustomer?.firstName || "Select Customer"}
                      </h6>
                    </div>
                  </div>
                  <Badge color="info" pill>
                    {itemsToShow.length} Item{itemsToShow.length > 1 ? "s" : ""}
                  </Badge>
                </CardHeader>
                <CardBody className="p-3">
                  <div className="table-responsive rounded border mb-3 d-lg-block d-md-block d-none">
                    <Table
                      bordered
                      hover
                      responsive
                      className="align-middle mb-0"
                    >
                      <thead className="table-light text-center">
                        <tr>
                          <th className="text-level-3">#</th>
                          <th className="text-level-3">Item</th>
                          <th className="text-end text-level-3">
                            Complementary Qty
                          </th>
                          <th className="text-end text-level-3"> Total Qty</th>
                          <th className="text-end text-level-3">Price (Rs)</th>
                          <th className="text-end text-level-3">Total (Rs)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemsToShow.map((item, index) => {
                          const itemKey = `${item?.tableId}-${index}`;
                          const isExpanded = expandedItems[itemKey];

                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td className="text-center text-level-3">
                                  {index + 1}
                                </td>

                                <td className="text-level-2">
                                  <h6
                                    className={`fw-semibold  mb-1 ${
                                      item?.children?.length > 0 ||
                                      item?.attributes?.length > 0
                                        ? "text-secondary cursor-pointer"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleChildren(itemKey);
                                    }}
                                  >
                                    {item?.productName}
                                    {item?.complimentaryQuantity > 0 && (
                                      <span className="ms-2 text-success">
                                        🎁 {item.complimentaryQuantity}
                                      </span>
                                    )}
                                  </h6>

                                  {/* Collapsible Children */}
                                  <div
                                    className="overflow-hidden"
                                    style={{
                                      maxHeight: isExpanded
                                        ? `${item.children?.length * 50}px`
                                        : "0px",
                                      transition: "max-height 0.3s ease",
                                    }}
                                  >
                                    {item?.children?.map((childItem, indx) => (
                                      <div
                                        key={childItem.id || indx}
                                        className="mt-2"
                                      >
                                        <div className="d-flex justify-content-between">
                                          <small>
                                            + {childItem.productName}
                                          </small>
                                          <small>
                                            {childItem?.productPrice}
                                          </small>
                                        </div>

                                        {childItem?.attributes?.map((attr) => (
                                          <small
                                            key={attr.id}
                                            className="text-muted d-block ms-2"
                                          >
                                            - {attr.title}
                                          </small>
                                        ))}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Collapsible Attributes */}
                                  <div
                                    className="overflow-hidden"
                                    style={{
                                      maxHeight: isExpanded
                                        ? `${item.attributes?.length * 50}px`
                                        : "0px",
                                      transition: "max-height 0.3s ease",
                                    }}
                                  >
                                    {item?.attributes?.map(
                                      (childItem, indx) => (
                                        <div key={indx} className="mt-2">
                                          <div className="d-flex justify-content-between">
                                            <small>+ {childItem.title}</small>
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </td>

                                {/* Complimentary Quantity */}
                                <td className="text-end text-level-3">
                                  {item?.complimentaryQuantity || 0}
                                </td>
                                <td className="text-end text-level-3">
                                  {item?.finalQuantity || item?.quantity || 0}
                                </td>

                                {/* Unit Price */}
                                {item?.attributes?.length > 0 ? (
                                  <td className="text-end text-level-3">
                                    {(() => {
                                      const attrTotal =
                                        item?.attributes?.reduce(
                                          (sum, a) =>
                                            sum + (Number(a.value) || 0),
                                          0,
                                        );

                                      const childrenTotal =
                                        item?.children?.reduce(
                                          (sum, c) =>
                                            sum + (Number(c.productPrice) || 0),
                                          0,
                                        );

                                      const basePrice =
                                        Number(item?.productPrice) || 0;

                                      const finalUnitPrice =
                                        attrTotal || childrenTotal
                                          ? basePrice +
                                            attrTotal +
                                            childrenTotal
                                          : basePrice;

                                      return finalUnitPrice.toFixed(2);
                                    })()}
                                  </td>
                                ) : (
                                  <td className="text-end text-level-3">
                                    {item?.productPrice?.toFixed(2)}
                                  </td>
                                )}

                                {/* Total Price (quantity × unit price) */}
                                {item?.attributes?.length > 0 ? (
                                  <td className="text-end text-level-3">
                                    {(() => {
                                      const attrTotal =
                                        item?.attributes?.reduce(
                                          (sum, a) =>
                                            sum + (Number(a.value) || 0),
                                          0,
                                        );

                                      const childrenTotal =
                                        item?.children?.reduce(
                                          (sum, c) =>
                                            sum + (Number(c.productPrice) || 0),
                                          0,
                                        );

                                      const basePrice =
                                        Number(item?.productPrice) || 0;
                                      const quantity = Number(
                                        item?.finalQuantity ||
                                          item?.quantity ||
                                          0,
                                      );

                                      const finalUnitPrice =
                                        attrTotal || childrenTotal
                                          ? basePrice +
                                            attrTotal +
                                            childrenTotal
                                          : basePrice;

                                      return (
                                        finalUnitPrice * quantity
                                      ).toFixed(2);
                                    })()}
                                  </td>
                                ) : (
                                  <td className="text-end text-level-3">
                                    {(
                                      (item?.quantity || 0) *
                                      (item?.productPrice || 0)
                                    ).toFixed(2)}
                                  </td>
                                )}
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="gx-2 gy-3">
                    {/* Payment Mode */}
                    <Col
                      lg={{ size: 7, order: 1 }}
                      xl={{ size: 6, order: 1 }}
                      xs={{ size: 12, order: 2 }}
                    >
                      <Card>
                        <CardBody>
                          <h5 className="fw-semibold mb-3">Payment Mode</h5>
                          <Row className="g-2">
                            {data && (
                              <>
                                {/* Render the credit item */}
                                {(() => {
                                  const creditItem = data.find((item) =>
                                    item.name.toLowerCase().includes("credit"),
                                  );
                                  if (!creditItem) return null;

                                  return (
                                    <Col xs="6" sm="4" key="credit">
                                      <Button
                                        color={
                                          selectedPayments.some(
                                            (item) =>
                                              item.name === creditItem.name,
                                          )
                                            ? "primary"
                                            : "light"
                                        }
                                        className="w-100 text-capitalize d-flex justify-content-between align-items-center border shadow-sm"
                                        onClick={() => handleSelect(creditItem)}
                                      >
                                        <span className="text-truncate">
                                          {creditItem.name}
                                        </span>
                                      </Button>
                                    </Col>
                                  );
                                })()}

                                {/* Render all other items except the credit item */}
                                {data
                                  .filter(
                                    (item) =>
                                      !item.name
                                        .toLowerCase()
                                        .includes("credit"),
                                  )
                                  .map((item, index) => (
                                    <Col xs="6" sm="4" key={index}>
                                      <Button
                                        color={
                                          selectedPayments.some(
                                            (selected) =>
                                              selected.name === item.name,
                                          )
                                            ? "primary"
                                            : "light"
                                        }
                                        className="w-100 text-capitalize d-flex justify-content-between align-items-center border shadow-sm"
                                        onClick={() => handleSelect(item)}
                                      >
                                        <span className="text-truncate">
                                          {item.name}
                                        </span>
                                      </Button>
                                    </Col>
                                  ))}
                              </>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Summary & Discounts */}
                    <Col
                      lg={{ size: 5, order: 2 }}
                      xs={{ size: 12, order: 1 }}
                      xl={{ size: 6, order: 2 }}
                    >
                      <div>
                        <div className="d-flex flex-column gap-4">
                          {/* Sub Total */}
                          <Row className="align-items-center">
                            <Col xs="6" className="mb-2">
                              <h6 className="mb-0 fw-bold">Sub Total (Rs)</h6>
                            </Col>
                            <Col xs="6" className="text-end mb-2">
                              <span className="fw-bold text-success">
                                {calculateTotals.subTotal.toFixed(2)}
                              </span>
                            </Col>

                            <Col xs="12" md="6" className="mb-2">
                              <div className="d-flex justify-content-between align-content-center align-items-center">
                                <h6 className="fw-bold">Discount</h6>
                                {(discountPercent || discountAmount) &&
                                  !promoSuccess && (
                                    <div className="text-end">
                                      <button
                                        className="btn btn-light btn-sm"
                                        onClick={() => {
                                          setDiscountPercent("");
                                          setDiscountAmount("");
                                          setLastUpdated(null);
                                        }}
                                      >
                                        <i className="ri-close-line"></i>
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </Col>

                            <Col xs="12" md="6" className="mb-2">
                              <div className="d-flex gap-2 justify-content-end align-items-center">
                                <div className="position-relative w-50">
                                  <input
                                    type="number"
                                    placeholder="0"
                                    value={discountPercent}
                                    onChange={handlePercentChange}
                                    max="100"
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    disabled={promoSuccess}
                                  />
                                  <span className="position-absolute end-0 top-50 translate-middle-y pe-2 text-muted small">
                                    %
                                  </span>
                                </div>
                                <i className="bx bx-link-alt text-muted"></i>
                                <div className="position-relative w-50">
                                  <input
                                    type="number"
                                    placeholder="0.00"
                                    value={discountAmount}
                                    onChange={handleAmountChange}
                                    max={calculateTotals.subTotal}
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    disabled={promoSuccess}
                                  />

                                  <span className="position-absolute end-0 top-50 translate-middle-y pe-2 text-muted small">
                                    Rs
                                  </span>
                                </div>
                              </div>
                            </Col>

                            <Col xs="6" className="mb-2">
                              <h6 className="mb-0 fw-bold">
                                Total Amount (Rs)
                              </h6>
                            </Col>
                            <Col xs="6" className="text-end mb-2">
                              <span className="fw-bold text-success">
                                {calculateTotals.total.toFixed(2)}
                              </span>
                            </Col>

                            {selectedPayments?.map((item) => {
                              const isCredit = item.name
                                .toLowerCase()
                                .includes("credit");
                              const isCash = item.name
                                .toLowerCase()
                                .includes("cash");

                              if (isCash) {
                                // Calculate total of all OTHER payment methods
                                let otherPaymentsTotal = 0;
                                selectedPayments.forEach((pay) => {
                                  if (pay.id !== item.id) {
                                    const isOtherCredit = pay.name
                                      .toLowerCase()
                                      .includes("credit");
                                    const amount = isOtherCredit
                                      ? parseFloat(creditData?.amount || 0)
                                      : parseFloat(paymentAmounts[pay.id] || 0);
                                    otherPaymentsTotal += amount;
                                  }
                                });

                                const remainingAmount = Math.max(
                                  0,
                                  calculateTotals.total - otherPaymentsTotal,
                                );

                                return (
                                  <React.Fragment key={item.id}>
                                    <Col xs="12" className="mb-2">
                                      <Row>
                                        <Col
                                          xs="6"
                                          className="d-flex align-items-center"
                                        >
                                          <h6 className="mb-2 fw-bold">
                                            {item?.name}
                                          </h6>
                                        </Col>

                                        <Col xs="6">
                                          <div className="d-flex flex-column gap-1">
                                            {/* <small className="text-muted mb-1">
                                            Received Money
                                          </small> */}
                                            {(() => {
                                              const cashAmount = parseFloat(
                                                paymentAmounts[item.id] || 0,
                                              );
                                              const isExceeding =
                                                cashAmount >
                                                calculateTotals.total;

                                              return (
                                                <>
                                                  <input
                                                    type="text"
                                                    inputMode="decimal"
                                                    pattern="[0-9]*"
                                                    placeholder="Enter amount"
                                                    className={`form-control form-control-sm text-end ${
                                                      isExceeding
                                                        ? "border-danger"
                                                        : ""
                                                    }`}
                                                    value={
                                                      paymentAmounts[item.id] ||
                                                      ""
                                                    }
                                                    onChange={(e) => {
                                                      const value =
                                                        e.target.value;
                                                      if (
                                                        /^\d*\.?\d*$/.test(
                                                          value,
                                                        )
                                                      ) {
                                                        handleCreditAmountChange(
                                                          item.id,
                                                          value,
                                                        );
                                                      }
                                                    }}
                                                  />
                                                  {isExceeding && (
                                                    <small className="text-danger fw-semibold">
                                                      Max allowed: Rs{" "}
                                                      {calculateTotals.total.toFixed(
                                                        2,
                                                      )}
                                                    </small>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        </Col>
                                      </Row>
                                      {/* <Row className="g-2"> */}
                                    </Col>
                                    {/* <Col xs="6">
                                        <div className="d-flex flex-column">
                                          <small className="text-muted mb-1">
                                            Remaining Amount
                                          </small>
                                          <input
                                            type="text"
                                            readOnly
                                            placeholder="0.00"
                                            className="form-control form-control-sm text-end bg-light"
                                            value={remainingAmount.toFixed(2)}
                                          />
                                        </div>
                                      </Col> */}
                                    {/* </Row>
                                  </Col> */}
                                  </React.Fragment>
                                );
                              }

                              return (
                                <React.Fragment key={item.id}>
                                  <Col
                                    xs="6"
                                    className="mb-2 d-flex align-items-center"
                                  >
                                    <h6 className="mb-0 fw-bold">
                                      {item?.name}
                                    </h6>
                                  </Col>
                                  <Col xs="6" className="text-end mb-2">
                                    <div className="d-flex flex-column gap-1">
                                      <div className="d-flex gap-2">
                                        {isCredit && (
                                          <Button
                                            size="sm"
                                            outline
                                            color="danger"
                                            className="ms-2"
                                            onClick={() =>
                                              setSelectedPayments((prev) =>
                                                prev.filter(
                                                  (p) => p.id !== item.id,
                                                ),
                                              )
                                            }
                                          >
                                            <i className="bx bx-x"></i>
                                          </Button>
                                        )}
                                        {(() => {
                                          // Calculate remaining for non-credit payments
                                          let otherPaymentsTotal = 0;
                                          selectedPayments.forEach((pay) => {
                                            if (pay.id !== item.id) {
                                              const isPayCredit = pay.name
                                                .toLowerCase()
                                                .includes("credit");
                                              const amount = isPayCredit
                                                ? parseFloat(
                                                    creditData?.amount || 0,
                                                  )
                                                : parseFloat(
                                                    paymentAmounts[pay.id] || 0,
                                                  );
                                              otherPaymentsTotal += amount;
                                            }
                                          });
                                          const maxAllowed = Math.max(
                                            0,
                                            calculateTotals.total -
                                              otherPaymentsTotal,
                                          );
                                          const currentAmount = parseFloat(
                                            paymentAmounts[item.id] || 0,
                                          );
                                          const isExceeding =
                                            currentAmount > maxAllowed;

                                          return (
                                            <input
                                              type="text"
                                              inputMode="decimal"
                                              pattern="[0-9]*"
                                              placeholder="Amount"
                                              className={`form-control form-control-sm text-end ${
                                                isCredit && isExceeding
                                                  ? "border-danger"
                                                  : ""
                                              }`}
                                              value={
                                                isCredit
                                                  ? creditData?.amount || 0
                                                  : paymentAmounts[item.id] || 0
                                              }
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d*$/.test(value)) {
                                                  isCredit
                                                    ? (() => {
                                                        // Calculate other payments total
                                                        let otherPaymentsTotal = 0;
                                                        selectedPayments.forEach(
                                                          (pay) => {
                                                            if (
                                                              pay.id !== item.id
                                                            ) {
                                                              const isPayCredit =
                                                                pay.name
                                                                  .toLowerCase()
                                                                  .includes(
                                                                    "credit",
                                                                  );
                                                              const amount =
                                                                isPayCredit
                                                                  ? 0 // Skip other credit entries
                                                                  : parseFloat(
                                                                      paymentAmounts[
                                                                        pay.id
                                                                      ] || 0,
                                                                    );
                                                              otherPaymentsTotal +=
                                                                amount;
                                                            }
                                                          },
                                                        );

                                                        // Calculate remaining for credit
                                                        const remainingForCredit =
                                                          Math.max(
                                                            0,
                                                            calculateTotals.total -
                                                              otherPaymentsTotal,
                                                          );

                                                        // Validate that credit amount doesn't exceed remaining
                                                        const creditAmount =
                                                          parseFloat(value) ||
                                                          0;
                                                        if (
                                                          creditAmount >
                                                          remainingForCredit
                                                        ) {
                                                          toast.error(
                                                            `Credit amount cannot exceed Rs ${remainingForCredit.toFixed(
                                                              2,
                                                            )}`,
                                                          );
                                                          return;
                                                        }

                                                        setCreditData(
                                                          (prev) => ({
                                                            ...prev,
                                                            amount: value,
                                                          }),
                                                        );
                                                      })()
                                                    : handleCreditAmountChange(
                                                        item.id,
                                                        value,
                                                      );
                                                }
                                              }}
                                            />
                                          );
                                        })()}
                                      </div>
                                      {(() => {
                                        let otherPaymentsTotal = 0;
                                        selectedPayments.forEach((pay) => {
                                          if (pay.id !== item.id) {
                                            const isPayCredit = pay.name
                                              .toLowerCase()
                                              .includes("credit");
                                            const amount = isPayCredit
                                              ? parseFloat(
                                                  creditData?.amount || 0,
                                                )
                                              : parseFloat(
                                                  paymentAmounts[pay.id] || 0,
                                                );
                                            otherPaymentsTotal += amount;
                                          }
                                        });
                                        const maxAllowed = Math.max(
                                          0,
                                          calculateTotals.total -
                                            otherPaymentsTotal,
                                        );
                                        const currentAmount = parseFloat(
                                          paymentAmounts[item.id] || 0,
                                        );
                                        const isExceeding =
                                          currentAmount > maxAllowed;

                                        // Only show max allowed message for credit payments
                                        return isCredit && isExceeding ? (
                                          <small className="text-danger fw-semibold">
                                            Max allowed: Rs{" "}
                                            {maxAllowed.toFixed(2)}
                                          </small>
                                        ) : null;
                                      })()}
                                    </div>
                                  </Col>
                                </React.Fragment>
                              );
                            })}
                            <hr />
                            <Col
                              xs={6}
                              className="mb-2 d-flex align-items-center"
                            >
                              <h6 className="mb-0 fw-bold text-danger">
                                Return Amount (Rs)
                              </h6>
                            </Col>
                            <Col xs={6} className="text-end mb-2">
                              <h6 className="mb-0 fw-bold text-danger">
                                {returnAmount.toFixed(2)}
                              </h6>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col
              md={5}
              lg={4}
              className="sticky-column d-lg-block d-sm-block d-none"
            >
              <InvoiceSummary
                orgInfo={orgInfo}
                user={user}
                selectedTable={selectedTable}
                orderId={orderId}
                items={itemsToShow}
                rawOrder={rawOrder}
                calculateTotals={calculateTotals}
                paymentStatus={paymentStatus}
                selected={selected}
                handleSelect={handleSelect}
                handleCheckout={handleCheckout}
                promoSuccess={promoSuccess}
                discountAmount={discountAmount}
                discountPercent={discountPercent}
                selectedCustomer={selectedCustomer}
                selectedPayment={selectedPayment}
                selectedPayments={selectedPayments}
                isValidAmount={isValidAmount}
                responseData={responseData}
                userInfo={userInfo}
                handleUnmergeTable={handleUnmergeTable}
                returnAmount={returnAmount}
                totalPaid={totalPaid}
              />
            </Col>
          </Row>
          <div className="p-2 rounded-3 border-2 shadow-sm bg-white position-sticky d-flex d-lg-none d-sm-none justify-content-between sticky-bottom align-items-center">
            <div>
              <p className="mb-0 text-muted small">Net sales amount1</p>
              <h6 className="fw-bold mb-0 text-success">
                Rs {calculateTotals.total.toFixed(2)}
              </h6>
            </div>

            <Button
              color="success"
              className="px-4 shadow-sm"
              disabled={isConfirmLoading}
              onClick={async () => {
                // Prevent multiple clicks
                if (isConfirmLoading) {
                  return;
                }

                if (!isValidAmount()) {
                  toast.error(
                    "Please enter valid payment amount(s) that match the total.",
                  );
                  return;
                }

                // Check if total paid is less than bill total
                if (totalPaid < calculateTotals.total) {
                  toast.error(
                    `Insufficient payment. Need Rs ${calculateTotals.total.toFixed(
                      2,
                    )}, entered Rs ${totalPaid.toFixed(2)}`,
                  );
                  return;
                }

                // Check if return amount is NOT exactly 0
                if (returnAmount !== 0) {
                  toast.error(
                    `Payment amount must equal total exactly. Return amount must be 0, currently Rs ${returnAmount.toFixed(
                      2,
                    )}`,
                  );
                  return;
                }

                setIsConfirmLoading(true);
                try {
                  await handleCheckout();
                } finally {
                  setIsConfirmLoading(false);
                }
              }}
            >
              {isConfirmLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Processing...
                </>
              ) : (
                "Confirm1"
              )}
            </Button>
          </div>
          <InvoiceSummaryMobile
            isOpen={isInvoiceOpen}
            toggle={toggleInvoice}
            orgInfo={orgInfo}
            user={user}
            selectedTable={selectedTable}
            orderId={orderId}
            items={itemsToShow}
            calculateTotals={calculateTotals}
            paymentStatus={paymentStatus}
            selected={selected}
            handleSelect={handleSelect}
            handleCheckout={handleCheckout}
            promoSuccess={promoSuccess}
            discountAmount={discountAmount}
            discountPercent={discountPercent}
            selectedCustomer={selectedCustomer}
            selectedPayment={selectedPayment}
            rawOrder={rawOrder}
            userInfo={userInfo}
          />

          <CreditModal
            isOpen={isCreditOpen}
            toggle={toggleCreditModal}
            setCreditData={setCreditData}
            creditData={creditData}
            setIsCreditOpen={setIsCreditOpen}
            initialCustomer={selectedCustomer}
            resetCredit={resetCredit}
            calculateTotals={calculateTotals}
            selectedPayments={selectedPayments}
            paymentAmounts={paymentAmounts}
            maxCreditAllowed={Math.max(
              0,
              calculateTotals.total -
                selectedPayments
                  .filter((p) => !p.name.toLowerCase().includes("credit"))
                  .reduce(
                    (sum, p) => sum + (parseFloat(paymentAmounts[p.id]) || 0),
                    0,
                  ),
            )}
          />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default ConfirmPayment;
